// @flow

import * as React from "react";
import Block from "../../components/Block/Block";
import Page from "../../components/Page/Page";
import Article from "../../components/Article/Article";
import task from "./task";

import "./instructions.css";

const FermiInstructions = () => {
  // The API for `renderQuestion` takes a `Task`. This is a hacky way (by creating a dummy task) to render
  // the question in the same way. FIXME: templates should provide a component that we can use
  // more directly below
  const question = task.renderQuestion({
    id: "",
    question: "3 * weight of an African elephant in kg < 10350",
    answer: false,
    responseTimesInSeconds: [],
    metadata: {},
    project: { id: "", name: "", template: "" }
  });
  return (
    <Page>
      <Article>
        <h1>Fermi Arithmetic Problems</h1>

        <p>In each round of the game, you will see two quantities like this:</p>

        <Block className="Fermi-Instructions-Example">{question}</Block>

        <h2>Instructions</h2>
        <ol>
          <li>
            Your task is to estimate which quantity of the two quantities is
            bigger.
          </li>
          <li>
            First, you’ll make a quick guess (after 20 seconds) and then you’ll
            guess again after 60 seconds and 3 minutes.
          </li>
          <li>
            <b>
              You cannot use Google or a calculator. No tools are allowed other
              than pen and paper!
            </b>
          </li>
        </ol>
        <p>
          Do you understand the instructions? If not, ping us using the
          messenger in the bottom right corner.
        </p>
      </Article>
    </Page>
  );
};

export default FermiInstructions;



// WEBPACK FOOTER //
// ./src/templates/fermi/instructions.js